import { createInstance } from '@amplitude/analytics-browser';

export const analyticsStore = {
  title: null,
};

export const pageViewPlugin = () => {
  return {
    name: 'page-view-tracking-enrichment',
    type: 'enrichment',
    setup: async () => undefined,
    execute: async (event) => {
      if (event.event_type !== '[Amplitude] Page Viewed') {
        return event;
      }

      if (!analyticsStore.title) {
        return null;
      }

      event.event_properties = {
        ...event.event_properties,
        '[Amplitude] Page Title': analyticsStore.title,
      };
      return event;
    },
  };
};

const Amplitude = createInstance();

Amplitude.add(pageViewPlugin());

export { Amplitude };